import { apiClient } from '@api/apiClient';
import { V4ApiResponse } from '@api/types';
import { CHANGE_TRACKING_SOURCES } from '@changeTracking/utils/changeTrackingRegistry';
import { buildChangeTrackingRequestConfig } from '@changeTracking/utils/buildChangeTrackingHeaders';
import { ToastType } from '@components/Toast';
import { Playlist } from '@store/orders/types';
import { createError } from '@utils/errorUtils';
import { handleToast } from '@utils/utils';

import { Group } from './types';

export async function savePlaylistService(
  playlist: Playlist,
  disableToast = false,
) {
  try {
    let response: V4ApiResponse<Playlist>;
    if (playlist.id === 0) {
      response = await apiClient.post(
        '/playlist',
        playlist,
        buildChangeTrackingRequestConfig([
          CHANGE_TRACKING_SOURCES.carrierPlaylists.carrierPlaylistsCreate,
        ]),
      );
    } else {
      response = await apiClient.put(
        '/playlist',
        {
          ...playlist,
          operationType: 'Update',
        },
        buildChangeTrackingRequestConfig([
          CHANGE_TRACKING_SOURCES.carrierPlaylists.carrierPlaylistsUpdate,
        ]),
      );
    }
    if (response.isSuccess && !disableToast) {
      handleToast(
        ToastType.Success,
        `Playlist ${playlist.id === 0 ? 'created' : 'updated'} successfully`,
      );
      return response.value;
    }
  } catch (error: unknown) {
    const e = createError(error, 'There was a issue saving the playlist');
    handleToast(ToastType.Error, e.message);
  }
}

export async function deletePlaylistService(playlistId: number) {
  try {
    const res: V4ApiResponse<null> = await apiClient.delete(
      `/playlist/${playlistId}`,
      buildChangeTrackingRequestConfig([
        CHANGE_TRACKING_SOURCES.carrierPlaylists.carrierPlaylistsDelete,
      ]),
    );

    if (Boolean(res.isSuccess)) {
      handleToast(ToastType.Success, 'Playlist deleted successfully');
      return true;
    }
    return false;
  } catch (error: unknown) {
    handleToast(ToastType.Error, 'There was a issue deleting the playlist');
    return false;
  }
}

export async function fetchCarrierOfficeGroupsCall(officeId: number) {
  try {
    const response: V4ApiResponse<Group[]> = await apiClient.get(
      `Office/groupdetailbyId/${officeId}`,
    );
    return response.value;
  } catch (error: unknown) {
    handleToast(ToastType.Error, 'There was a issue fetching office groups.');
    throw new Error(JSON.stringify(error));
  }
}
